import { cn } from '@/lib/utils';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-12 px-6 text-center',
        className
      )}
    >
      {icon && (
        <div className="w-16 h-16 bg-neutral-light rounded-full flex items-center justify-center mb-4 text-neutral-medium">
          {icon}
        </div>
      )}
      <h3 className="text-lg font-semibold text-neutral-dark mb-2">{title}</h3>
      {description && (
        <p className="text-neutral-medium max-w-sm mb-6">{description}</p>
      )}
      {action}
    </div>
  );
}
